import styled from 'styled-components';

export const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 20000;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.colors.BG1};
`;

export const Content = styled.div`
  width: 700px;
  float: left;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;

  img {
    margin: 0 0 10px 0;
  }
`;

export const Message = styled.div`
  font-weight: 700;
  color: ${({ theme }) => theme.colors.TEXT1};

  font-size: 20px;
  text-align: center;
  font-weight: normal;
  background: ${({ theme }) => theme.colors.LIGHT1};
  border-radius: 10px;
  padding: 10px;

  @media (max-width: 1024px) {
    font-size: 20px;
  }
`;

export const SubMessage = styled.div`
  color: ${({ theme }) => theme.colors.TEXT1};
  font-size: 12px;
  margin: 5px 0 20px 0;
  padding: 0 50px;
  text-align: center;
  font-weight: normal;

  @media (max-width: 1024px) {
    font-size: 12px;
  }
`;

export const Back = styled.button`
  background: ${({ theme }) => theme.colors.BTNBG};
  color: ${({ theme }) => theme.colors.BTNLABEL};

  padding: 20px;
  cursor: pointer;
  font-size: 18px;
  font-weight: 700;
  outline: none;
  border-radius: 0.6rem;
  transition: all 0.5s ease;
  text-align: center;
  border: none;

  &:hover {
    background: ${({ theme }) => theme.colors.BTNBGH};
    color: ${({ theme }) => theme.colors.BTNLABELH};
  }

  @media (max-width: 1024px) {
    font-size: 16px;
  }
`;
